import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { isAdminJudge } from '../utils/roles';
import CompetitionBadge from './CompetitionBadge';

export default function AdminHeader() {
  const { user, logout } = useAuth();
  const { pathname }     = useLocation();

  // Dashboard only, matching the judge and entrant headers: a prominent
  // "leave this page" button does not belong on a song review or a results page.
  const showSwitch = isAdminJudge(user) && pathname === '/admin/dashboard';

  return (
    <>
      <header className="c-header">
        <Link to="/admin/dashboard" className="c-header__logo">
          <span className="scala">SCALA</span>{' '}
          <span className="scala">FOOM</span>{' '}
          <span className="c-header__logo-sub">Administration</span>
          <CompetitionBadge />
        </Link>

        <div className="c-header__right">
          <span className="c-header__user">{user?.full_name}</span>
          <button onClick={logout} className="c-header__logout">
            Sign out
          </button>
        </div>
      </header>

      {/* Only an admin who is also a judge sees this. Login lands them on the
          admin dashboard, so without it their assigned songs are reachable but
          not findable. */}
      {showSwitch && (
        <div className="c-roleswitch">
          <span className="c-roleswitch__label">You are also judging this year</span>
          <Link to="/judge/dashboard" className="c-btn c-roleswitch__btn">
            Switch to judge view →
          </Link>
        </div>
      )}
    </>
  );
}
